import ModelGroup from './ModelGroup'
import Employee from './Employee'
export class SaveModelGroupRequest {
    ModelGroup: ModelGroup;
    SavedByEmployee: Employee;
}

export default SaveModelGroupRequest;